import './modal-header.scss';

function ModalHeader({...props}) {
    return (
        <div className="modal-header">
            {props.children}
        </div>
    )
}

export default ModalHeader;